// extracted by mini-css-extract-plugin
export var active = "_2o-9";
export var backButton = "_2o-8";
export var clone = "_2o-e";
export var collapseBar = "_2o-j";
export var collapseMode = "_2o-l";
export var collapsed = "_2o-n";
export var dragHandle = "_2o-c";
export var dropdownIcon = "_2o-g";
export var expanding = "_2o-m";
export var hidden = "_2o-w";
export var iconContainer = "_2o-p";
export var iconSwapper = "_2o-v";
export var navItem = "_2o-6";
export var navItemIcon = "_2o-f";
export var navProfile = "_2o-7";
export var notificationCountBadge = "_2o-i";
export var notificationDot = "_2o-q";
export var optionsContainer = "_2o-h";
export var primaryNav = "_2o-0";
export var primaryNavDivider = "_2o-u";
export var primaryNavResizeHandle = "_2o-2";
export var primaryNavResizing = "_2o-1";
export var primaryNavTabSection = "_2o-t";
export var primaryTab = "_2o-o";
export var primaryTabIconBox = "_2o-r";
export var secondaryNav = "_2o-3";
export var selected = "_2o-s";
export var settingsNav = "_2o-4";
export var settingsNavItems = "_2o-5";
export var show = "_2o-d";
export var sideNav = "_2o-k";
export var teamItem = "_2o-a";
export var userProfileItem = "_2o-b";